import { render, staticRenderFns } from "./order-details.vue?vue&type=template&id=c7f395e4&scoped=true"
import script from "./order-details.vue?vue&type=script&lang=js"
export * from "./order-details.vue?vue&type=script&lang=js"
import style0 from "./order-details.vue?vue&type=style&index=0&id=c7f395e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f395e4",
  null
  
)

export default component.exports